/* WaterFun: full product title on hover (2026-07-19).
 *
 * Product/collection card titles are clamped to 2 lines by base.css
 * (-webkit-line-clamp: 2), so long names end in "...". The FULL title is
 * already in the DOM, so the cleanest, most accessible way to reveal it
 * on hover is the native "title" attribute - no layout shift, works on
 * every card variant and for keyboard/screen-reader users, and needs no
 * change to the (frozen) card-product.liquid.
 *
 * We add "title" ONLY to headings that are actually truncated, and
 * re-apply after the AJAX filter/sort re-renders #ProductGridContainer.
 */
(function () {
  'use strict';

  function apply(scope) {
    var root = scope || document;
    var headings = root.querySelectorAll('.card__heading');
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      var link = h.querySelector('a');
      if (!link) continue;
      // Truncated when the (clamped) box hides overflowing lines.
      if (h.scrollHeight > h.clientHeight + 1) {
        var full = link.textContent.trim();
        if (full) link.setAttribute('title', full);
      } else if (link.hasAttribute('title')) {
        link.removeAttribute('title');
      }
    }
  }

  function init() {
    apply(document);

    // Re-apply after collection filtering/sorting swaps the grid HTML.
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        // Wait a frame so the new cards have their final layout/height.
        requestAnimationFrame(function () {
          pending = false;
          apply(grid);
        });
      }).observe(grid, { childList: true, subtree: true });
    }

    // Fonts can load after DOMContentLoaded and change line wrapping.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { apply(document); });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
